import { checkRouteToPermissionsMap } from "@/utils/development/route";
import routeToPermissionsMap from "@/router/routeToPermissionsMap";

checkRouteToPermissionsMap(routeToPermissionsMap);
